import { render, staticRenderFns } from "./ConsignmentList.vue?vue&type=template&id=f84ce75e&"
import script from "./ConsignmentList.vue?vue&type=script&lang=js&"
export * from "./ConsignmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports